var _event = 'TEAMCONFIG_EVENT';
var _eventKey = 'teamConfig';

function customUserEvent(value) {
  var event = new Event(_event);
  event.key = _eventKey;
  event.newValue = value;
  window.dispatchEvent(event);
}
/**
 * 获取teamConfig信息
 * @function
 */


export var getTeamConfig = function getTeamConfig() {
  return window.teamConfig || {};
};
/**
 * 设置teamConfig信息
 * @function
 */

export var setTeamConfig = function setTeamConfig(data) {
  window.teamConfig = data;
  customUserEvent(data);
};